import React from 'react';
import t from 'prop-types';

var EntradaTipoSubunidad = function EntradaTipoSubunidad(_ref) {
  var numUnidad = _ref.numUnidad,
      titulo = _ref.titulo,
      onClick = _ref.onClick;
  return React.createElement('div', {
    className: 'unidadIndice' + numUnidad + ' subUnidad',
    onClick: onClick
  }, React.createElement('div', {
    className: 'bullet'
  }), React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  }));
};

EntradaTipoSubunidad.propTypes = process.env.NODE_ENV !== "production" ? {
  numUnidad: t.string,
  titulo: t.string,
  onClick: t.func
} : {};
export default EntradaTipoSubunidad;